<div class="row">
    <div class="col-12">
        <div class="marqueeDiv">
            <marquee> {{message}}</marquee>
        </div>
    </div>
</div>